export default "__VITE_ASSET__Din7Ojtx__"